/* eslint-disable react/prop-types */
/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { Button, Drawer, Modal, Form, Input, Select, Collapse, Tooltip, Icon, Tag, message } from 'antd';
import styled from 'styled-components';
import moment from 'moment';
import Attachments from '~/containers/Attachments';
import { copyToClipBoard } from '~/utils/copy-to-clipboard';
import { request } from '~/components/Instance';
import { updateSolicitation, deleteSolicitation as deleteSolicitationAction } from '../actions';
import { useDispatch } from 'react-redux';

var TextArea = Input.TextArea;
var Panel = Collapse.Panel;
var Option = Select.Option;

/* ─── Styled Components ─── */

var HeaderSection = styled.div`
    padding: 24px 24px 16px;
    border-bottom: 1px solid #f0f0f0;
`;

var HeaderTop = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 12px;
`;

var ProtocolWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

var Protocol = styled.span`
    font-size: 20px;
    font-weight: 700;
    color: rgba(0, 0, 0, 0.85);
    font-variant-numeric: tabular-nums;
`;

var CopyBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.2s;

    &:hover {
        background: rgba(0, 0, 0, 0.04);
        color: rgba(0, 0, 0, 0.65);
    }
`;

var StatusTag = styled(Tag)`
    font-size: 13px;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 16px;
    border: none;
    margin: 0;
`;

var MetaRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    font-size: 13px;
`;

var MetaItem = styled.div`
    color: rgba(0, 0, 0, 0.45);

    span {
        color: rgba(0, 0, 0, 0.75);
        font-weight: 500;
    }
`;

var SectionLabel = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.65);
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
`;

var ContentArea = styled.div`
    padding: 20px 24px;
    padding-bottom: 80px;
    overflow-y: auto;
    height: calc(100vh - 200px);
`;

var ResponseSection = styled.div`
    background: #fafafa;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    padding: 20px;
    margin-top: 20px;
`;

var NfeCard = styled.div`
    background: #fff;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 8px;
    cursor: pointer;
    transition: border-color 0.15s;

    &:hover {
        border-color: #d9d9d9;
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

var NfeCardTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
`;

var NfeCardName = styled.span`
    font-size: 14px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.85);
`;

var NfeCardAmount = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: #1890ff;
`;

var NfeCardMeta = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
`;

var InfoRow = styled.div`
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 6px 0;
    font-size: 14px;

    .label {
        color: rgba(0, 0, 0, 0.4);
        font-size: 13px;
        min-width: 100px;
        flex-shrink: 0;
    }
    .value {
        color: rgba(0, 0, 0, 0.85);
    }
`;

var FooterBar = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 12px 24px;
    background: #fff;
    border-top: 1px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 10;
`;

var DeleteLink = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: rgba(0, 0, 0, 0.25);
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
        color: #ff4d4f;
    }
`;

/* ─── Component ─── */

var ViewSolicitation = function(props) {
    var data = props.data;
    var onClose = props.onClose;
    var form = props.form;

    if (!data) return '';

    var solicitation_type = data.solicitation_type;
    var description = data.description;
    var uid = data.uid;
    var getFieldDecorator = form.getFieldDecorator;
    var _useState = useState(false);
    var loading = _useState[0];
    var setLoading = _useState[1];
    var dispatch = useDispatch();

    var isArchived = !!data.deleted_at;
    var statusKey = isArchived ? 'archived' : data.status === 1 ? 'completed' : 'pending';
    var statusLabel = isArchived ? 'Arquivado' : data.status === 1 ? 'Concluído' : 'Pendente';
    var statusColor = isArchived ? '#8c8c8c' : data.status === 1 ? '#52c41a' : '#fa8c16';

    var customerName = data.customer ? (data.customer.cod + ' - ' + data.customer.name) : '—';
    var userName = '';
    if (data.app_user_id && data.customer && data.customer.app_users) {
        var found = data.customer.app_users.find(function(u) { return u.id === data.app_user_id; });
        userName = (found && found.name) || '';
    }

    var nfeItems = Array.isArray(data.custom_data) ? data.custom_data : [];
    var submitter = data.custom_data && data.custom_data.submitter;
    var uploadFile = data.custom_data && data.custom_data.upload_file;

    var handleDelete = function(id) {
        Modal.confirm({
            title: 'Excluir solicitação',
            content: 'Tem certeza? Esta ação não poderá ser desfeita.',
            okText: 'Excluir',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk: function() {
                return dispatch(deleteSolicitationAction(id)).then(function() {
                    onClose(false);
                    message.success('Solicitação excluída');
                }).catch(function() {
                    message.error('Erro ao excluir solicitação');
                });
            },
        });
    };

    var doSubmit = function(values) {
        setLoading(true);
        values = Object.assign({}, data, values);
        dispatch(updateSolicitation(data.id, values)).then(function() {
            setLoading(false);
            onClose(false);
            message.success('Solicitação atualizada');
        }).catch(function() {
            setLoading(false);
            message.error('Erro ao salvar solicitação');
        });
    };

    var handleSubmit = function() {
        form.validateFields(function(err, values) {
            if (err) return;

            request('get', 'files/solicitations/' + uid + '_response', null, false)
                .then(function(response) {
                    var files = (response.data && response.data.data) || [];
                    if (files.length === 0) {
                        Modal.confirm({
                            title: 'Nenhum arquivo anexado',
                            content: 'Você não anexou nenhum arquivo de resposta. Deseja salvar mesmo assim?',
                            okText: 'Salvar mesmo assim',
                            cancelText: 'Cancelar',
                            onOk: function() {
                                doSubmit(values);
                            },
                        });
                    } else {
                        doSubmit(values);
                    }
                })
                .catch(function() {
                    doSubmit(values);
                });
        });
    };

    var handleCopyProtocol = function() {
        if (!data.protocol) return;
        copyToClipBoard(data.protocol);
        message.success('Protocolo copiado');
    };

    var handleCopyNfeField = function(text) {
        if (!text) return;
        copyToClipBoard(text);
        message.success('Copiado');
    };

    return (
        <Drawer
            title={null}
            placement="right"
            closable={true}
            onClose={onClose}
            width={720}
            visible
            headerStyle={{ display: 'none' }}
            bodyStyle={{ padding: 0 }}
        >
            {/* Header */}
            <HeaderSection>
                <HeaderTop>
                    <div>
                        <div style={{ fontSize: 12, color: 'rgba(0,0,0,0.4)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 4 }}>
                            Protocolo
                        </div>
                        <ProtocolWrapper>
                            <Protocol>{data.protocol || '—'}</Protocol>
                            {data.protocol && (
                                <Tooltip title="Copiar protocolo">
                                    <CopyBtn onClick={handleCopyProtocol}>
                                        <Icon type="copy" />
                                    </CopyBtn>
                                </Tooltip>
                            )}
                        </ProtocolWrapper>
                    </div>
                    <StatusTag color={statusColor}>{statusLabel}</StatusTag>
                </HeaderTop>
                <MetaRow>
                    <MetaItem>
                        <Icon type="shop" style={{ marginRight: 4 }} />
                        <span>{customerName}</span>
                    </MetaItem>
                    {userName && (
                        <MetaItem>
                            <Icon type="user" style={{ marginRight: 4 }} />
                            <span>{userName}</span>
                        </MetaItem>
                    )}
                    {submitter && (
                        <MetaItem>
                            <Icon type="global" style={{ marginRight: 4 }} />
                            <span>{submitter.name}</span>
                            {submitter.email && <span style={{ color: 'rgba(0,0,0,0.35)', marginLeft: 4 }}>{submitter.email}</span>}
                        </MetaItem>
                    )}
                    {data.created_at && (
                        <MetaItem>
                            <Icon type="calendar" style={{ marginRight: 4 }} />
                            <span>{moment(data.created_at).format('DD/MM/YYYY [às] HH:mm')}</span>
                        </MetaItem>
                    )}
                </MetaRow>
            </HeaderSection>

            {/* Content */}
            <ContentArea>
                {/* Collapsible details */}
                <Collapse defaultActiveKey={nfeItems.length > 0 ? ['1'] : []} bordered={false} style={{ background: 'transparent' }}>
                    <Panel
                        header={
                            <span style={{ fontWeight: 600, fontSize: 13 }}>
                                <Icon type="file-text" style={{ marginRight: 6 }} />
                                Detalhes da Solicitação
                            </span>
                        }
                        key="1"
                        style={{ border: '1px solid #f0f0f0', borderRadius: 10, marginBottom: 16, overflow: 'hidden' }}
                    >
                        <div style={{ padding: '4px 0' }}>
                            <InfoRow>
                                <span className="label">Tipo</span>
                                <span className="value">{solicitation_type}</span>
                            </InfoRow>
                            {description && (
                                <InfoRow>
                                    <span className="label">Observações</span>
                                    <span className="value">{description}</span>
                                </InfoRow>
                            )}
                            {uploadFile && (
                                <InfoRow>
                                    <span className="label">Arquivo</span>
                                    <span className="value">
                                        <Icon type="paper-clip" style={{ marginRight: 4, color: '#1890ff' }} />
                                        {uploadFile.original_name}
                                    </span>
                                </InfoRow>
                            )}
                        </div>

                        {/* NF-e cards */}
                        {nfeItems.length > 0 && (
                            <div style={{ marginTop: 12 }}>
                                <SectionLabel>
                                    <Icon type="file-text" />
                                    Notas Fiscais ({nfeItems.length})
                                </SectionLabel>
                                {nfeItems.map(function(item, index) {
                                    return (
                                        <NfeCard key={item.key || index}>
                                            <NfeCardTop>
                                                <Tooltip title="Clique para copiar o nome">
                                                    <NfeCardName onClick={function() { handleCopyNfeField(item.name); }} style={{ cursor: 'pointer' }}>
                                                        {item.name || 'Sem nome'}
                                                    </NfeCardName>
                                                </Tooltip>
                                                {item.amount && (
                                                    <Tooltip title="Clique para copiar o valor">
                                                        <NfeCardAmount onClick={function() { handleCopyNfeField(item.amount); }} style={{ cursor: 'pointer' }}>
                                                            R$ {item.amount}
                                                        </NfeCardAmount>
                                                    </Tooltip>
                                                )}
                                            </NfeCardTop>
                                            <NfeCardMeta>
                                                {item.doc && (
                                                    <Tooltip title="Clique para copiar">
                                                        <span onClick={function() { handleCopyNfeField(item.doc); }} style={{ cursor: 'pointer' }}>{item.doc}</span>
                                                    </Tooltip>
                                                )}
                                                {item.cod && <span>Cód. Serviço: {item.cod}</span>}
                                                {item.description && <span>{item.description}</span>}
                                            </NfeCardMeta>
                                        </NfeCard>
                                    );
                                })}
                            </div>
                        )}

                        {/* Uploaded attachments */}
                        <div style={{ marginTop: 12 }}>
                            <Attachments
                                source={'solicitations'}
                                entity={uid}
                                initialFiles={[]}
                                canUpload={false}
                                canDelete={false}
                            />
                        </div>
                    </Panel>
                </Collapse>

                {/* Response section - always visible (read-only if archived) */}
                {isArchived ? (
                    <ResponseSection>
                        <SectionLabel>
                            <Icon type="message" />
                            Resposta
                        </SectionLabel>
                        {data.awnser ? (
                            <div style={{ fontSize: 14, color: 'rgba(0,0,0,0.65)', lineHeight: 1.6 }}>{data.awnser}</div>
                        ) : (
                            <div style={{ fontSize: 14, color: 'rgba(0,0,0,0.25)', fontStyle: 'italic' }}>Sem resposta</div>
                        )}
                        <div style={{ marginTop: 12 }}>
                            <SectionLabel>
                                <Icon type="paper-clip" />
                                Arquivos de Resposta
                            </SectionLabel>
                            <Attachments
                                source={'solicitations'}
                                entity={uid + '_response'}
                                initialFiles={[]}
                                canUpload={false}
                                canDelete={false}
                            />
                        </div>
                    </ResponseSection>
                ) : (
                    <ResponseSection>
                        <SectionLabel>
                            <Icon type="message" />
                            Resposta
                        </SectionLabel>
                        <Form layout="vertical">
                            <Form.Item label="Status" style={{ marginBottom: 16 }}>
                                {getFieldDecorator('status', {
                                    initialValue: data.status,
                                    rules: [{ required: true, message: 'Selecione o status' }],
                                })(
                                    <Select size="large" style={{ borderRadius: 8 }}>
                                        <Option value={0}>
                                            <Icon type="clock-circle" style={{ color: '#fa8c16', marginRight: 6 }} />
                                            Pendente
                                        </Option>
                                        <Option value={1}>
                                            <Icon type="check-circle" style={{ color: '#52c41a', marginRight: 6 }} />
                                            Concluído
                                        </Option>
                                    </Select>
                                )}
                            </Form.Item>
                            <Form.Item label="Resposta ao cliente" style={{ marginBottom: 16 }}>
                                {getFieldDecorator('awnser', {
                                    initialValue: data.awnser,
                                })(<TextArea rows={4} placeholder="Escreva uma resposta para o cliente..." style={{ borderRadius: 8 }} />)}
                            </Form.Item>
                            <SectionLabel style={{ marginTop: 8 }}>
                                <Icon type="paper-clip" />
                                Arquivos de Resposta
                            </SectionLabel>
                            <Attachments
                                source={'solicitations'}
                                entity={uid + '_response'}
                                initialFiles={[]}
                            />
                        </Form>
                    </ResponseSection>
                )}
            </ContentArea>

            {/* Footer */}
            <FooterBar>
                {isArchived ? (
                    <div style={{ fontSize: 13, color: 'rgba(0,0,0,0.35)' }}>
                        <Icon type="delete" style={{ marginRight: 4 }} />
                        Arquivado
                    </div>
                ) : (
                    <DeleteLink onClick={function() { handleDelete(data.id); }}>
                        <Icon type="delete" /> Excluir
                    </DeleteLink>
                )}
                <div style={{ display: 'flex', gap: 8 }}>
                    <Button size="large" onClick={function() { onClose(false); }} style={{ borderRadius: 8 }}>
                        Fechar
                    </Button>
                    {!isArchived && (
                        <Button
                            type="primary"
                            size="large"
                            onClick={handleSubmit}
                            loading={loading}
                            style={{ borderRadius: 8, fontWeight: 600 }}
                        >
                            <Icon type="save" /> Salvar
                        </Button>
                    )}
                </div>
            </FooterBar>
        </Drawer>
    );
};

export default Form.create()(ViewSolicitation);
